import type {SVGProps} from 'react';

/*
 * «Внимание» из макетов MPGO (icon/fill/20/attention, SKS-380): оранжевый треугольник
 * с восклицательным знаком. Контуры сняты из Figma как есть — у 20 и 24 пикселей
 * они разные, а не масштаб одного, поэтому и компонента два.
 *
 * <defs> с clipPath из экспорта снят по той же причине, что в CountryFlags: прямоугольник
 * во весь холст ничего не отсекает (svg обрезает по viewBox сам), а id в нём конфликтовал
 * бы, когда иконка на экране дважды — в модалке и в баннере под ней.
 */

export function AttentionIcon20(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden {...props}>
			<path
				d="M7.37491 1.76801C8.51511 -0.301463 11.4891 -0.30218 12.6298 1.76704L19.6767 14.5512C20.7788 16.5506 19.3327 18.9994 17.0497 18.9995H2.95792C0.675398 18.9991 -0.770531 16.5515 0.330963 14.5522L7.37491 1.76801ZM10.0048 12.9995C9.17646 12.9995 8.50495 13.6712 8.50479 14.4995C8.50479 15.3279 9.17636 15.9995 10.0048 15.9995C10.8332 15.9994 11.5048 15.3278 11.5048 14.4995C11.5046 13.6712 10.8331 12.9995 10.0048 12.9995ZM10.0038 4.49946C9.4517 4.49903 9.00355 4.94644 9.00284 5.49848L8.99893 10.4985C8.9985 11.0507 9.44576 11.4989 9.99796 11.4995C10.5501 11.4998 10.9984 11.0526 10.9989 10.5004L11.0028 5.50044C11.0031 4.94841 10.5558 4.50008 10.0038 4.49946Z"
				fill="#FE9133"
			/>
		</svg>
	);
}

export function AttentionIcon24(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
			<path
				d="M9.37518 1.16755C10.5155 -0.90155 13.4895 -0.901544 14.6301 1.16755L24.1027 18.3521C25.2046 20.3514 23.7586 22.8002 21.4758 22.8004H2.53436C0.251668 22.8002 -1.19416 20.3515 -0.0925937 18.3521L9.37518 1.16755ZM12.006 15.6002C11.012 15.6002 10.2053 16.4059 10.2053 17.4C10.2053 18.3941 11.0119 19.1998 12.006 19.1998C13 19.1996 13.8058 18.394 13.8058 17.4C13.8058 16.406 13 15.6004 12.006 15.6002ZM12.0041 5.60017C11.4521 5.59996 11.0036 6.04713 11.0031 6.59919L10.9982 12.5992C10.9978 13.1512 11.4453 13.5994 11.9973 13.6002C12.5494 13.6006 12.9976 13.1533 12.9982 12.6011L13.0031 6.60114C13.0035 6.04899 12.5562 5.60081 12.0041 5.60017Z"
				fill="#FE9133"
			/>
		</svg>
	);
}
